import { render, staticRenderFns } from "./table-print.vue?vue&type=template&id=4b04a079&scoped=true"
import script from "./table-print.vue?vue&type=script&lang=js"
export * from "./table-print.vue?vue&type=script&lang=js"
import style0 from "./table-print.vue?vue&type=style&index=0&id=4b04a079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04a079",
  null
  
)

export default component.exports